(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('CovidIcd10', CovidIcd10);

    CovidIcd10.$inject = ['$resource'];

    function CovidIcd10 ($resource) {
        var resourceUrl =  'api/covid-icd-10-s/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByFilter': {
                url: 'api/covid-icd-10-s/filter',
                method: 'GET',
                isArray: true
            }
        });
    }
})();
